import {call, put, select, takeLatest} from 'redux-saga/effects';
import {
    PROGRAM_METADATA_QUERY_START,
    ProgramMetadataQueryStartAction,
    getProgramMetadataQuerySuccessAction,
    getProgramMetadataQueryFailedAction
} from "../actions/ProgramMetadataAction";
import ApiUtil from "src/utils/ApiUtil";
import {ProgramMetadata} from "src/model/ProgramMetadata";
import MetricsUtil from "src/utils/MetricsUtil";
import {defaultPrograms, IRCIndiaProgramNameMap, IRCUrlProgramName, isWidget} from "src/config/Config";
import get from "lodash/get";


export function* getProgramMetadata(action: ProgramMetadataQueryStartAction) {
    try {
        let parameters: any = {countryCode: action.countryCode, asin: action.queryProduct.asin};
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "getprograms", parameters);

        let metricsUtil = MetricsUtil.getMetricsUtil();
        let programMetadataArray: Array<ProgramMetadata> = response.programInfoList;
        let updatedResponse;
        //IRC only display seller enrolled program. It depends on program parameter from URL. Set program in frontend.
        if (isWidget() && action.countryCode == 'IN') {
            const programOfIndia = get(IRCIndiaProgramNameMap, IRCUrlProgramName, defaultPrograms);
            programMetadataArray = programMetadataArray.filter(
                (item) => programOfIndia.includes(item.name)
            );
        }

        updatedResponse = { ...response, programInfoList: programMetadataArray };
        programMetadataArray.map((programMetadata, index) => {
            let programName = programMetadata.name;
            if (metricsUtil && programName != 'MFN' && programName != 'Core') {
                metricsUtil.publishCounter(programName, "ProgramEligibility");
            }
        });

        yield put(getProgramMetadataQuerySuccessAction(updatedResponse));
    } catch (error) {
        console.error("Call API getprograms error" + error)
        yield put(getProgramMetadataQueryFailedAction());
        return;
    }


}

export default function* programMetadata() {
    yield takeLatest([PROGRAM_METADATA_QUERY_START], getProgramMetadata);
}
